import api from "../../Axios/middleware";
import {
    getCourseTutorMappingList,
    successGetCourseTutorMappingList,
    failureGetCourseTutorMappingList,
    createEditCourseTutorMapping,
    successCreateEditCourseTutorMapping,
    failureCreateEditCourseTutorMapping,
    getAvailableTutorList,
    successGetAvailableTutorList,
    failureGetAvailableTutorList,
} from "./CourseTutorMappingSlice";

export const getCourseTutorMapping = (id?: number, course_id?: string, tutor_ids?: number[]) => {
    return async (dispatch: any) => {
        try {
            dispatch(getCourseTutorMappingList());
            
            let queryParams = new URLSearchParams();
            if (id !== undefined) queryParams.append('id', id.toString());
            if (course_id) queryParams.append('course_id', course_id);
            if (tutor_ids && tutor_ids.length > 0) {
                tutor_ids.forEach(tutorId => queryParams.append('tutor_ids', tutorId.toString()));
            }
            
            const url = queryParams.toString() 
                ? `/api/course-tutor-mapping/?${queryParams.toString()}`
                : `/api/course-tutor-mapping/`;
                
            const response = await api.get(url);
            
            if (response.data?.status) {
                dispatch(successGetCourseTutorMappingList(response));
            } else {
                dispatch(failureGetCourseTutorMappingList(response));
            }
        } catch (error) {
            dispatch(failureGetCourseTutorMappingList({
                status: false,
                message: "Failed to fetch course tutor mappings",
                error: error
            }));
        }
    };
};

export const createEditCourseTutorMappingAction = (inputData: any) => {
    return async (dispatch: any) => {
        try {
            dispatch(createEditCourseTutorMapping());
            
            const response = await api.post(
                `/api/course-tutor-mapping/`,
                inputData
            );
            
            if (response.data?.status) {
                dispatch(successCreateEditCourseTutorMapping(response));
            } else {
                dispatch(failureCreateEditCourseTutorMapping(response));
            }
        } catch (error) {
            dispatch(failureCreateEditCourseTutorMapping({
                status: false,
                message: "Failed to create/edit course tutor mapping",
                error: error
            }));
        }
    };
};

export const getAvailableTutors = () => {
    return async (dispatch: any) => {
        try {
            dispatch(getAvailableTutorList());
            const response = await api.get(`/api/course-tutor-mapping/available-tutors`);
            if (response.data?.status) {
                dispatch(successGetAvailableTutorList(response));
            } else {
                dispatch(failureGetAvailableTutorList(response));
            }
        } catch (error) {
            dispatch(failureGetAvailableTutorList({
                status: false,
                message: "Failed to fetch available tutors",
                error: error
            }));
        }
    };
};
